module.exports = __webpack_public_path__ + "img/contact.e5be250e.png";